export default __webpack_public_path__ + "static/media/world-map.5e18398b.png";